/** @description 页面公共组件 */
import React, { useEffect, useState } from 'react';
import { bus } from '@/utils/bus';
import RotateCaptchaModal from '@/pages/xiaohongshu/components/captcha';

const PageMain: React.FC = (props) => {
  const mainStyle = {
    background: '#fff',
    padding: 20,
    borderRadius: 10,
  } as React.CSSProperties;
  const containerStyle = {
    padding: 20,
    minHeight: 'calc(100vh - 48px)',
  } as React.CSSProperties;

  const [captcha, setCaptcha] = useState<{
    visible: boolean;
    name: string;
    verifyUuid: string;
    verifyType?: string; // 可选，默认为 '102'
    rid: string;
    backgroundUrl: string;
    centerUrl: string;
  }>({
    visible: false,
    name: '',
    verifyUuid: '',
    verifyType: '102', // 默认值为 '102'
    rid: '',
    backgroundUrl:
      'https://picasso-static.xiaohongshu.com/bg_cn4s394001210.png',
    centerUrl:
      'https://picasso-static.xiaohongshu.com/center_cn4s394001210.png',
  });

  useEffect(() => {
    const handler = (payload: any) => {
      setCaptcha({ visible: true, ...payload });
    };
    bus.on('captcha:show', handler);
    return () => bus.off('captcha:show', handler);
  }, []);

  return (
    <div style={containerStyle}>
      <main style={mainStyle}>
        <RotateCaptchaModal
          visible={captcha.visible}
          onClose={() => setCaptcha((s) => ({ ...s, visible: false }))}
          name={captcha.name}
          rid={captcha.rid}
          verifyUuid={captcha.verifyUuid}
          verifyType={captcha.verifyType} // 默认值为 '102'
          backgroundUrl={captcha.backgroundUrl}
          centerUrl={captcha.centerUrl}
          bgDisplayWidth={336}
          pieceExtraPx={0}
          onVerify={(_, ok) => {
            if (ok) setCaptcha((s) => ({ ...s, visible: false }));
          }}
        />
        {props.children}
      </main>
    </div>
  );
};

export default PageMain;
